import React from "react";
import {
  RadarChartOutlined,
  InstagramOutlined,
  ImportOutlined,
  AlertOutlined,
  NodeIndexOutlined,
  FolderOpenOutlined,
  DeploymentUnitOutlined,
  LockOutlined,
  SettingOutlined,
  AimOutlined,
  FieldTimeOutlined,
  FireOutlined,
  GlobalOutlined,
  ControlOutlined,
  FileSyncOutlined,
  TeamOutlined
} from '@ant-design/icons';

import MessagePrompt from './messagePrompt'


// label 菜单名称
// key 菜单主键 用于路由跳转
// icon 菜单图标
// children 子菜单 数组
// parent 父级菜单key
// permissionkey  权限id  必须是(number)类型！！！！！！，如果无权限则为('')  
function getItem (label, key, icon, children, parent = '', permissionkey) {
  return { label, key, icon, children, parent, permissionkey };
}

export const MenuList = [
  getItem('实时画面', '/Video', <InstagramOutlined />, '', '', ''),
  // getItem('机场镜头', '/AirportCamera', <InstagramOutlined />, '', '', ''),

  getItem('机场镜头', 'AirportCamera', <InstagramOutlined />, [
    getItem('机场镜头', '/airport_camera', '', '', 'AirportCamera', ''),
    getItem('机场监控', '/airport_surveillance', '', '', 'AirportCamera', ''),
  ], '', ''),

  getItem('GIS总览', '/pipeline_overview', <DeploymentUnitOutlined />, '', '', ''),
  getItem('GIS编辑', '/GIS', <RadarChartOutlined />, '', '', 486),
  getItem('航线列表', 'ShippingLine', <NodeIndexOutlined />, [
    getItem('管网巡检', '/new_pipeline_inspection', '', '', 'ShippingLine', 500),
    getItem('管道巡检', '/routine_list_conduit', '', '', 'ShippingLine', 1),

    // -------------涪陵--------------
    getItem('电网巡检', '/routine_list_powerGrid', '', '', 'ShippingLine', 139),
    getItem('电网巡检_新', '/routine_list_powerGrid_new', '', '', 'ShippingLine', 558),

    // -------------普光--------------
    // getItem('电网巡检_旧', '/routine_list_powerGrid', '', '', 'ShippingLine', 139),
    // getItem('电网巡检', '/routine_list_powerGrid_new', '', '', 'ShippingLine', 558),

    getItem('电塔巡检', '/fixedPoint_list_electricTower', '', '', 'ShippingLine', 142),
    getItem('场站巡检', '/fixedPoint_list_station', '', '', 'ShippingLine', 143),
  ], '', 115),
  getItem('任务规划', '/TaskPlan', <FieldTimeOutlined />, '', '', 138),

  getItem(<MessagePrompt type={'4'} />, '/AbnormalTroubleshooting', <AlertOutlined />, '', '', 14),//异常排查
  getItem(<MessagePrompt type={'1'} />, '/routine_risk_conduit', <AimOutlined />, '', '', 19),//管道风险
  getItem(<MessagePrompt type={'7'} />, '/routine_risk_powerGrid', <AimOutlined />, '', '', 148),//电网风险
  getItem(<MessagePrompt type={'8'} />, '/fixedPoint_risk_electricTower', <AimOutlined />, '', '', 151),//电塔风险
  getItem(<MessagePrompt type={'9'} />, '/fixedPoint_risk_station', <AimOutlined />, '', '', 177),//场站风险

  getItem('巡检记录', 'InspectionRecords', <FolderOpenOutlined />, [
    getItem('管道巡检记录', '/routine_record_conduit', '', '', 'InspectionRecords', 25),
    getItem('电网巡检记录', '/routine_record_powerGrid', '', '', 'InspectionRecords', 192),
    getItem('电塔巡检记录', '/fixedPoint_record_electricTower', '', '', 'InspectionRecords', 213),
    getItem('场站巡检记录', '/fixedPoint_record_station', '', '', 'InspectionRecords', 216),
  ], '', 137),

  // getItem('应急保障', '/emergency_support_record', <FolderOpenOutlined />, '', '', ''),

  getItem('巡检报告', '/inspection_report', <FileSyncOutlined />, '', '', 29),

  getItem('巡检上帝图', 'godMap', <GlobalOutlined />, [
    getItem('管道上帝图', '/godMap_conduit', '', '', 'godMap', 258),
    getItem('电网上帝图', '/godMap_powerGrid', '', '', 'godMap', 261),
  ], '', 255),

  // getItem('显表类型设置', '/DisplayTable', <SettingOutlined />, '', '', 127),

  getItem('风险处理员', 'riskHandlers', <TeamOutlined />, [
    getItem('人员', '/risk_handlers', '', '', 'riskHandlers', 258),
    getItem('组队', '/risk_handlers_team', '', '', 'riskHandlers', 261),
  ], '', ''),
  // getItem('修改密码', '/ChangePassword', <LockOutlined />, '', '', ''),
  // getItem('用户手册', '/UsersManual', <BookOutlined />, '', '', ''),

  getItem('设置', '/settings', <SettingOutlined />, [
    getItem('风险识别', '/risk_identification', '', '', 'settings', 381),
    getItem('短信通知', '/SMS_notification', '', '', 'settings', 471),
    getItem('权限', '/permission_settings', '', '', 'settings', 135),
    getItem('机场', '/airport', '', '', 'settings', 136),
  ], '', ''),
  // getItem('退出登录', '/login', <ImportOutlined />, '', '', ''),
];

